// extracted by mini-css-extract-plugin
export default {"conflictContainer":"_2nI9F","shakeWrapper":"_2enrq","title":"_1JEr7","conflictButton":"_1eryo","container":"_1NnJR","noMoneyComponent":"_1gzZi"};